import DOMPurify from 'dompurify';

export const REQUIRED_FILER_NOTES_PLACEHOLDER = '[Required: Filer Notes]';
export const OPTIONAL_FILER_NOTES_PLACEHOLDER = '[Optional: Filer Notes]';

export function isLikelyHtmlContent(content: string): boolean {
    return /<\/?[a-z][\s\S]*?>/i.test(content);
}

/** Sanitized HTML for admin template preview (renders like email body). */
export function sanitizeTemplatePreviewHtml(html: string): string {
    return DOMPurify.sanitize(html);
}

/** Plain text for previews when HTML should not be shown as markup. */
export function templatePreviewPlainText(content: string): string {
    return DOMPurify.sanitize(content, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}

export function applySampleMergeValues(
    body: string,
    sampleValues: Record<string, string> = {},
): string {
    let out = body;
    Object.entries(sampleValues).forEach(([key, value]) => {
        out = out.split(key).join(value);
    });
    return out;
}

export function validateMessageTemplateForm(params: {
    source: string;
    subject: string;
    body: string;
    originalBody: string;
    restricted: boolean;
    errorCode: boolean;
    adminConfirmed: boolean;
}): string | null {
    if (!params.body.trim()) {
        return 'Message body is required.';
    }
    if (params.source === 'email' && !params.subject.trim()) {
        return 'Subject is required.';
    }
    if (params.restricted && !params.adminConfirmed) {
        return 'Please confirm this restricted template change has been reviewed with dev.';
    }
    if (params.errorCode) {
        const original = params.originalBody || '';
        if (original.includes(REQUIRED_FILER_NOTES_PLACEHOLDER)
            && !params.body.includes(REQUIRED_FILER_NOTES_PLACEHOLDER)) {
            return 'This template requires the [Required: Filer Notes] tag — removing it will break the error code workflow.';
        }
        if (original.includes(OPTIONAL_FILER_NOTES_PLACEHOLDER)
            && !params.body.includes(OPTIONAL_FILER_NOTES_PLACEHOLDER)) {
            return 'This template had [Optional: Filer Notes] — removing it may break optional-note flows.';
        }
    }
    return null;
}
